import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListIcon from "@material-ui/icons/List";
import CustomSwitch from "../../components/Switch/CustomSwitch";
import { tesaBlue } from "../../styles/colors";
import ViewModeButton from "./ViewModeButton";
import ViewMode from "../../models/ViewMode";

const useStyles = makeStyles({
  dashboardIcon: {
    color: tesaBlue,
    marginRight: "11px",
    width: "18px",
  },
  viewControlsInnerContainer: {
    display: "flex",
    flexDirection: "row",
  },
});

interface ViewControlsProps {
  expandedAdvancedSearch: boolean;
  expandedKpiView: boolean;
  toggleExpandedAdvancedSearch: () => void;
  toggleExpandedKpiView: () => void;
  toggleViewMode: () => void;
  viewMode: ViewMode;
}

const ViewControls = (props: ViewControlsProps) => {
  const classes = useStyles();
  const {
    expandedAdvancedSearch,
    expandedKpiView,
    toggleExpandedAdvancedSearch,
    toggleExpandedKpiView,
    toggleViewMode,
    viewMode,
  } = props;

  return (
    <Box className={classes.viewControlsInnerContainer}>
      <CustomSwitch label="Show KPIs" SwitchProps={{ checked: expandedKpiView, onChange: toggleExpandedKpiView }} />
      <ViewModeButton
        text={expandedAdvancedSearch ? "Back to Basic Search" : "Go to Advanced Search"}
        onClick={toggleExpandedAdvancedSearch}
        startIcon={<SearchIcon style={{ marginRight: "11px", color: tesaBlue }} />}
      />
      <ViewModeButton
        onClick={toggleViewMode}
        text={`View ${viewMode ? "Table" : "Board"}`}
        startIcon={
          viewMode ? (
            <ListIcon className={classes.dashboardIcon} />
          ) : (
            <DashboardIcon className={classes.dashboardIcon} />
          )
        }
      />
    </Box>
  );
};

export default ViewControls;
